<template>
    <section>
        <div class="  ml-6 p-6 md:ml-0 md:p-2 md:text-sm md:border-0 w-2/3">
            <p>By deleting your account, you will no longer have access to carryGo admin system.</p>
            <p @click="showModal" class="text-red-500 cursor-pointer mt-4 border border-red-500 p-1 w-1/4 text-center rounded-lg" >Delete</p>
        </div>
        <DeleteModal
        v-show="deleteModal"
        @close="closeModal"
        @deleteAccount="deleteAccount"
        :userId="userId"
        />
    </section>
</template>

<script>
import axios from 'axios';
import DeleteModal from './DeleteModal.vue';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    components:{DeleteModal},
    data() {
        return {
            userId : localStorage.getItem('userId'),
            deleteStatus : "deleted",
            deleteModal : false,
        }
    },

    mounted() {
        this.networkError()
    },

    methods: {
        closeModal() {
            this.deleteModal = false
        },
        goBack() {
            this.$router.go(-1)
        },
        showModal() {
            this.deleteModal = true
        },
        deleteAccount() {
            axios({
                method: 'PUT',
                url: `${url}/v1/web/users/${this.userId}`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    status : this.deleteStatus
                }
            })
            .then((response) => {
                response;
                localStorage.removeItem('ipAddress')
             localStorage.removeItem('user')
             localStorage.removeItem('refereshToken')
             localStorage.removeItem('userEmail')
             localStorage.removeItem('userType')
             localStorage.removeItem('token')
             localStorage.removeItem('userId')
            this.$router.push("/admin/login");
            })
            .catch((error) => {
                console.log(error)
            })
        },

        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
}
</script>